/* import __COLOCATED_TEMPLATE__ from './recently-used-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();